import { CHANGE_CUSTOMER_PASSWORD, REPLAY_CONSULTATION, UPDATE_CUSTOMER_DETAILS, UPDATE_CUSTOMER_EMAIL } from './../graphql/mutations/mutations';
import { CUSTOMER_CONSULTATIONS, CONSULTATIONS_REPLIES, CONSULTATION, CUSTOMER, CUSTOMER_APPOINTMENTS, VALIDATE_CUSTOMER_TOKEN } from './../graphql/queries/queries';
import { CustomerConsultationsInput, GetConsultationInput, GetConsultationRepliesInput, PaginationOptions, GetCustomerAppointmentsInput, ConsultationInput, DeleteConsultationInput, successPayload, UpdateCustomerDetailsInput, UpdateCustomerEmailInput, ChangePasswordInput, ConsultationReplyInput } from './../graphql/types/types';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { DELETE_CONSULTATION, SEND_CONSULTATION } from '../graphql/mutations/mutations';

@Injectable({
	providedIn: 'root'
})
export class AccountService {

	constructor(private apollo: Apollo,) { }

	listCustomerConsultations(Obj: CustomerConsultationsInput) {
		return this.apollo.query<any>({
			query: CUSTOMER_CONSULTATIONS,
			variables: { customerConsultationsInput: Obj }
		})
	}

	listConsultation(Obj: GetConsultationInput) {
		return this.apollo.query<any>({
			query: CONSULTATION,
			variables: { getConsultationInput: Obj }
		})
	}

	listConsultationReplies(Obj: GetConsultationRepliesInput) {
		return this.apollo.query<any>({
			query: CONSULTATIONS_REPLIES,
			variables: { getConsultationReplies: Obj }
		})
	}

	listCustomerAppointments(Obj: PaginationOptions) {
		return this.apollo.query<any>({
			query: CUSTOMER_APPOINTMENTS,
			variables: { paginationOptions: Obj }
		})
	}

	listCustomer() {
		return this.apollo.query<any>({
			query: CUSTOMER
		})
	}

	sendConsultation(Obj: ConsultationInput) {
		return this.apollo.mutate<any>({
			mutation: SEND_CONSULTATION,
			variables: { sendConsultationInput: Obj }
		})
	}

  addConsultationReplay(Obj: ConsultationReplyInput) {
    return this.apollo.mutate<ConsultationReplyInput>({
      mutation: REPLAY_CONSULTATION,
			variables: { replyConsultationInput: Obj }
    })
  }

	deleteConsultation(Obj: DeleteConsultationInput) {
		return this.apollo.mutate<any>({
			mutation: DELETE_CONSULTATION,
			variables: { deleteConsultationInput: Obj }
		})
	}

	validateCustomerToken() {
		return this.apollo.query<successPayload>({
			query: VALIDATE_CUSTOMER_TOKEN
		})
	}

	updateCustomerDetail(Obj:UpdateCustomerDetailsInput){
		return this.apollo.mutate<successPayload>({
			mutation: UPDATE_CUSTOMER_DETAILS,
			variables: { updateBuyerDetails: Obj }
		})
	}

	updateCustomerEmail(Obj:UpdateCustomerEmailInput){
		return this.apollo.mutate<successPayload>({
			mutation: UPDATE_CUSTOMER_EMAIL,
			variables: { updateCustomerEmailInput: Obj }
		})
	}

	changeCustomerPassword(Obj:ChangePasswordInput){
		return this.apollo.mutate<any>({
			mutation: CHANGE_CUSTOMER_PASSWORD,
			variables: { changePasswordInput: Obj }
		})

	}
}
